import TimeSlot from './TimeSlot';

export default class SelectedTimeSlot extends TimeSlot {
  public dateFormatted: string;

  public startTimeFormatted: string;

  public endTimeFormatted: string;

  public startEndTimeFormatted: string;

  constructor(
    id: number,
    start: Date,
    end: Date,
    dateFormatted: string,
    startTimeFormatted: string,
    endTimeFormatted: string,
    startEndTimeFormatted: string
  ) {
    super(id, start, end);

    this.dateFormatted = dateFormatted;
    this.startTimeFormatted = startTimeFormatted;
    this.endTimeFormatted = endTimeFormatted;
    this.startEndTimeFormatted = startEndTimeFormatted;
  }
}
